
















import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
  setup(props, ctx) {
    const theme = computed(() => {
      const dark = ctx.root.$vuetify.theme.dark;
      return dark
        ? {
            color: "rgba(255, 255, 255, .05)",
            light: false,
            dark: true
          }
        : {
            color: "rgba(0, 0, 0, .05)",
            light: true,
            dark: false
          };
    });

    return {
      theme
    };
  }
});
